

export default function (inputConfig, tableConfig, viewConfig) {
  if(inputConfig.filter) {
    tableConfig.system_filter=inputConfig.filter;
  }
  if(inputConfig.view_mode) {
    viewConfig.view_mode=inputConfig.view_mode;
  }
}